import styled from 'styled-components';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { Image } from '@/shared/ui/image/Image';

export const TimerContainer = styled.div`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  gap: 2px; 
  
  border-radius: 8px;
  background: rgba(98, 90, 99, 0.50);
  transition: all 0.2s ease;
`;

export const TimerIcon = styled(Image)`
  flex-shrink: 0;
  & img {
    width: 18px;
    height: 18px;
    filter: brightness(0) invert(1);
  }
`;

export const TimeValue = styled(BodyTextMediumC)`
  min-width: 32px; 
  text-align: left;
  flex-shrink: 0;
`;